var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:({ 
    '--sidebar-width': _vm.sidebarWidth,
    '--margin-top': _vm.isTotemAccessibility ? _vm.messageHeight : _vm.marginTop,
    '--margin-bottom': _vm.isTotemAccessibility ? '400px' : _vm.marginBottom
  })},[_c('texto-menu-activo'),(_vm.menus)?_c('table',{staticClass:"sidebar-menu"},_vm._l((_vm.menus),function(item,index){return _c('tr',{key:index},[_c('td',[_c('sidebar-item',{attrs:{"data":item,"index":index}})],1)])}),0):_vm._e(),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }